import React from 'react'
import { twMerge } from 'tailwind-merge'

function RightIcon({size=24, className='', containerClass=''}) {
  return (
    <svg width={24} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={containerClass}>
      <path 
        d="M8.91003 19.92L15.43 13.4C16.2 12.63 16.2 11.37 15.43 10.6L8.91003 4.07996"
        stroke="#0C0507"
        stroke-width="2"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
        className={twMerge('stroke-current',className)}
      />
    </svg>
  )
}

export default RightIcon